<template>
  <div class="sb-menu--btn_group">
    <button
      :class="{ 'sb-menu--isOpen': menuOpen }"
      class="sb-menu--btn sb-menu--btn-open sb-btn--primary"
      @click="toggleMenu"
      aria-label="shopbox button"
    >
      <notification-counter></notification-counter>
      <template v-if="client == 'interfloradk'">
        <template v-if="!openIcon">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 30 30"
            style="enable-background: new 0 0 30 30"
            xml:space="preserve"
          >
            <path
              d="M3.1,26c0,2.1,2,3.9,4.4,3.9h15c2.4,0,4.4-1.7,4.4-3.8l0-0.1L25.1,6.6c0-0.3-0.3-0.6-0.7-0.6h-3.7l0-0.1
	c0-3.1-2.6-5.7-5.8-5.7S9.3,2.7,9.2,5.8l0,0.1H5.5C5.2,6,4.9,6.2,4.9,6.6L3.1,26z M10.6,5.8c0.1-2.4,2-4.3,4.4-4.3
	c2.4,0,4.4,1.9,4.4,4.3l0,0.2h-8.8L10.6,5.8z M6.2,7.3h3.1V10c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7V7.3h8.8V10
	c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7V7.3h3.1L25.5,26c0,1.4-1.4,2.5-3,2.5h-15c-1.6,0-3-1.1-3-2.4L6.2,7.3z"
            />
          </svg>
        </template>
        <template v-else>
          <icon icon="arrow"></icon>
        </template>
      </template>
      <template v-else>
        <icon v-if="!openIcon" icon="sb"></icon>

        <icon v-else icon="arrow"></icon>
      </template>
    </button>

    <button
      v-if="dnd === true"
      class="sb-menu--btn sb-btn--sm"
      v-dragged="onDragged"
      aria-label="shopbox drag and drop"
    >
      <icon icon="magnifier"></icon>
    </button>
  </div>
</template>

<script>
import icon from "./partials/Icon.vue";
import notificationCounter from "./partials/NotificationCounter.vue";
// import draggable from "vuedraggable";
import { mapState } from "vuex";
export default {
  components: { icon, notificationCounter },
  props: { searchConfig: Object, dnd: { type: Boolean, default: false } },
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "menuOpen",
      "ctaOpen",
      "crosssellOpen",
      "similarOpen",
      "recentOpen",
      "purchasedOpen",
      "panelList",
      "uuid",
      "c_page",
      "cart",
      "client",
      "dndEnabled",
      "similarEnabled",
      "recentEnabled",
    ]),
    openIcon: function () {
      return this.panelList
        .filter((p) => p !== "ctaOpen")
        .some((panel) => this[panel]);
    },
  },
  methods: {
    toggleMenu() {
      let anyPanelOpen = this.panelList.find((panel) => this[panel]);
      if (anyPanelOpen == undefined) {
        this.$store.commit("OPEN_PANEL", "menu");
      } else {
        this.$store.commit("CLOSE_PANEL", anyPanelOpen.split("Open")[0]);
      }
    },
    toggleSimilar(sku) {
      let tour = window.dndTour;

      if (tour && tour.isActive()) {
        document.body.classList.remove("sb-tutorial-arrow");
        setTimeout(() => {
          tour.next();
        }, 600);
      }
      this.$emit("toggleSimilar", {
        sku: sku,
        page: 1,
        toggle: true,
        reset: true,
        force: true,
      });
      this.$store.dispatch("emitEvent", {
        data: {
          page: this.c_page,
          productid: sku,
          sbAction: `FindSimilar`,
          site: this.client,
          source: "DnD",
          uuid: this.uuid,
        },
        headers: {},
        type: "sbaction",
      });
    },

    onDragged({ el, deltaX, deltaY, clientX, clientY, first, last }) {
      if (first) {
        document.body.setAttribute("style", "overflow:hidden !important");
        this.isDragging = true;
        return;
      }
      if (last) {
        this.isDragging = false;
        el.style.left = 0;
        el.style.top = 0;
        document.body.setAttribute("style", "overflow:visible");
        this.toggleSimilar(this.detectSku(clientX, clientY));
        return;
      }
      let l = +window.getComputedStyle(el)["left"].slice(0, -2) || 0;
      let t = +window.getComputedStyle(el)["top"].slice(0, -2) || 0;
      el.style.left = l + deltaX + "px";
      el.style.top = t + deltaY + "px";
    },
  },
  mounted() {},
};
</script>

<style scoped>
#shopbox .sb-menu--btn_group {
  position: fixed;
  transform: translate3d(0, 0, 0);
  bottom: 12px;
  left: 12px;
  display: flex;
  z-index: 2147483644;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
}
#shopbox .shopbox-right .sb-menu--btn_group {
  right: 12px;
  left: unset;
  flex-direction: row-reverse;
}
#shopbox .sb-menu--btn {
  width: 60px;
  height: 60px;
  background-color: var(--shopbox-main);
  outline: none;
  border: none;
  border-radius: 30% !important;
  cursor: pointer;
  padding: 4px;
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.2142);
  margin: 4px;
  min-width: unset !important;
  min-height: unset !important;
  position: relative;
  /* border: 2px solid #142626; */
}
#shopbox .sb-menu--btn.sb-btn--sm {
  width: 40px;
  height: 40px;
  border-radius: 50% !important;
  transition: none !important;
}
#shopbox .sb-menu--btn_group:after {
  content: "\2190";
  display: block;
  font-size: 70px;
  color: var(--shopbox-main);
  text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
  position: absolute;
  right: -70px;
  top: 70%;
  /* transform: translateY(-50%); */
  opacity: 0;
  visibility: hidden;
  font-family: sans-serif !important;
}
#shopbox .shopbox-right .sb-menu--btn_group:after {
  content: "\2192";
  right: unset;
  left: -70px;
}
</style>
